import React from "react";

import useFinancialData from "./useFinancialData";
import gettext from "../../shared/utils/gettext";
import DashboardTile from "../DashboardTile";
import DashBoardFinancialTileContent from "./DashBoardFinancialTileContent";

interface DashboardFinancialTileProps {
  className?: string;
  callback?: any;
}

function DashboardFinancialTile({
  className = "table-condensed table-b-t-0",
  callback = () => {},
}: DashboardFinancialTileProps) {
  const { data, error } = useFinancialData({});
  callback();
  return (
    <DashboardTile>
      <DashboardTile.Title>{gettext("Financial")}</DashboardTile.Title>
      <DashboardTile.Body>
        <DashBoardFinancialTileContent data={data} className={className} error={error} />
      </DashboardTile.Body>
      {!error && (
        <DashboardTile.Link
          url="/cropr/dashboard/#financial/"
          icon="sack-dollar"
          text={gettext("Financial overview")}
          logMetrics={true}
        />
      )}
    </DashboardTile>
  );
}

export default DashboardFinancialTile;
